import {
	createActionsHook,
	createHook,
	createStore,
	createContainer,
	createDefaultEocWrapper,
} from '@atlassian/eoc-rss-helpers';
import { useFlagService } from '@atlassian/jira-flags';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { emptyResource } from '../../../common/constants/index.tsx';
import type { StoreTeamsContainerProps } from '../../../common/types/index.tsx';
import { actions } from './actions/index.tsx';
import type { TeamsState } from './types.tsx';

export const initialState: TeamsState = {
	teams: emptyResource,
	hasTeams: false,
};

const Store = createStore({ initialState, actions, name: 'teams-step' });

const TeamsContainer = createContainer<
	TeamsState,
	typeof actions,
	{ children?: React.ReactNode; isGlobal?: boolean }
>(Store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): StoreTeamsContainerProps => {
			const { data: orgId } = useOrgId();
			const { atlassianAccountId, cloudId } = useTenantContext();
			const { showFlag } = useFlagService();

			return {
				orgId,
				accountId: atlassianAccountId,
				siteId: cloudId,
				showFlag,
			};
		},
	}),
});

const useTeamsStore = createHook(Store);
const useTeamsActions = createActionsHook(Store);

const useTeams = createHook(Store, {
	selector: (state) => ({
		teams: state.teams,
		hasTeams: (state.teams.data?.entities.length || 0) > 0,
	}),
});

export { useTeamsStore, useTeamsActions, useTeams, TeamsContainer };
